// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon___2UcIZ","BarrageBtn":"BarrageBtn___1Qplc","on":"on___89DRk"};